<template>
  <div class="return-order">
    <Form :model="formItem"
          ref="formItem"
          :inline="true"
          action="javascript:void(0)">
      <FormItem>
        <Input v-model="formItem.key"
               placeholder="输入订单编号..." />
      </FormItem>
      <FormItem>
        <Button type="primary"
                @click="renderTable('formItem')">筛选</Button>
      </FormItem>
    </Form>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <!-- 审核弹框 -->
    <Form :model="returndata"
          action="javascript:void(0)">
      <Modal v-model="showModalStatus"
             title="审核"
             @on-ok="reviewOrder()"
             :loading="dataloading">
        <FormItem label="审核状态"
                  label-position="top">
          <RadioGroup v-model="returndata.status">
            <Radio label="2">通过</Radio>
            <Radio label="-1">不通过</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="商家备注"
                  label-position="top">
          <Input type="textarea"
                 v-model="returndata.shopmark"
                 :rows="3"
                 placeholder="请输入描述" />
        </FormItem>
      </Modal>
    </Form>
    <!-- 审核弹框 end -->
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.current"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 退款详情弹层 start-->
    <Drawer width="50"
            v-model="modal2"
            title="退款详情"
            :mask-closable="false"
            @on-cancel="modal2 = false">
      <Form :model="detailphotodata"
            label-position="left"
            :label-width="100">
        <FormItem label="凭证">
          <div class="upload-list">
            <img v-for="item in detailphotodata.album"
                 :key="item"
                 :src="item"
                 style="width:88px;height:88px;margin: 0 20px;"
                 @click="showViewer(item)" />
          </div>
        </FormItem>
        <FormItem label="退货支付订单号">
          <span>{{ detailphotodata.pay_order_num }}</span>
        </FormItem>
        <FormItem label="商品单价">
          <span>{{ detailphotodata.price }}</span>
        </FormItem>
        <FormItem label="购买数量">
          <span>{{ detailphotodata.num }}</span>
        </FormItem>
        <FormItem label="商品金额">
          <span>{{ detailphotodata.total_price }}</span>
        </FormItem>
        <FormItem label="退货理由">
          <span v-html="detailphotodata.mark"></span>
        </FormItem>
        <FormItem label="商家处理结果">
          <span v-html="detailphotodata.shopmark"></span>
        </FormItem>
        <FormItem label="审核人员">
          <span>{{ detailphotodata.adminname }}</span>
        </FormItem>
        <FormItem label="是否收到货">
          <span>{{ detailphotodata.is_receive_good }}</span>
        </FormItem>
      </Form>
    </Drawer>
    <!-- 退款详情弹层 end -->
    <!-- 图片查看 start -->
    <viewer :options="viewerOptions"
            :images="viewerImages"
            @inited="inited"
            class="viewerImageWraper"
            ref="viewerImageWraper">
      <template slot-scope="scope">
        <figure class="images">
          <div class="image-wrapper"
               v-for="img in viewerImages"
               :key="img">
            <img class="image"
                 :src="img"
                 :data-source="img"
                 :alt="img"
                 style="display: none;" />
          </div>
        </figure>
      </template>
    </viewer>
    <!-- 图片查看 end -->
  </div>
</template>

<script>
export default {
  name: "return-order",
  data () {
    return {
      viewerOptions: {
        toolbar: true,
        url: "data-source"
      },
      loading: true,
      dataloading: true,
      showModalStatus: false,
      detailphotodata: {},
      viewerImages: [],
      modal2: false,
      formItem: {
        key: ""
      },
      loginst: [],
      returndata: {
        status: "1",
        shopmark: ""
      },
      pages: {
        current: 1,
        size: 10
      },
      list: [
        {
          title: "订单号",
          align: "center",
          key: "order_num",
          width: 185,
          fixed: "left"
        },

        {
          title: "会员名",
          width: 185,
          align: "center",
          key: "userdata"
        },
        {
          title: "商品信息",
          minWidth: 185,
          align: "center",
          key: "good_title"
        },
        {
          title: "商品数量",
          width: 120,
          align: "center",
          key: "num"
        },
        {
          title: "商品金额",
          width: 185,
          align: "center",
          key: "real_return_price"
        },
        {
          title: "退款金额",
          width: 185,
          align: "center",
          key: "total_price"
        },
        {
          title: "退款原因",
          width: 150,
          align: "center",
          key: "mark"
        },
        {
          title: "处理意见",
          minWidth: 150,
          align: "center",
          key: "shopmark"
        },
        {
          title: "审核状态",
          minWidth: 100,
          align: "center",
          key: "status"
        },
        {
          title: "退款状态",
          minWidth: 100,
          align: "center",
          key: "pay_status"
        },
        {
          title: "提交时间",
          minWidth: 100,
          align: "center",
          key: "created_at"
        },
        {
          title: "退货时间",
          minWidth: 100,
          align: "center",
          key: "pay_at"
        },
        {
          title: "操作",
          align: "center",
          key: "action",
          width: 200,
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id);
                    }
                  }
                },
                "详情"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display:
                      params.row.status == "未审核"
                        ? "inline-block"
                        : "none"
                  },
                  on: {
                    click: () => {
                      this.review(params.row.id);
                    }
                  }
                },
                "审核"
              )
            ]);

          }
        }
      ],
      tablelist: []
    };
  },
  // 计算
  computed: {},
  // 监听
  watch: {
  },
  created: function () {
    // 取数据
    this.getTableList();
  },
  methods: {
    inited (viewer) {
      this.$viewer = viewer;
    },
    // 获取订单列表
    getTableList: function () {
      var params = {
        page: this.pages.current,
        size: this.pages.size,
      };
      this.$api.mangheshopgoodreturnorder.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 分页
    changePage () {
      this.pages.current = this.$refs["listPage"].currentPage;
      this.getTableList();
    },
    // 删除
    remove: function (id) {
      this.$api.mangheshopgoodreturnorder.remove({ return_id: id }).then(res => {
        if (res.code == 200) {
          this.getTableList();
        }
      });
      return;
    },
    review: function (id) {
      this.return_id = id;
      this.returndata.shopmark = "";
      this.returndata.status = "1";
      this.showModalStatus = !this.showModalStatus;
    },
    // 添加
    reviewOrder: function (name) {
      this.$api.mangheshopgoodreturnorder
        .review({
          return_id: this.return_id,
          status: this.returndata.status,
          shopmark: this.returndata.shopmark
        })
        .then(res => {
          if (res.code == 200) {
            this.getTableList();
          }
        });
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true;
      });
    },
    // 查看订单详情
    detail: function (order_id) {
      this.modal2 = true;
      this.$api.mangheshopgoodreturnorder.detail({ id: order_id }).then(res => {
        if (res.code == 200) {
          this.detailphotodata = res.result;
          if (res.result.album != "") {
            this.detailphotodata.album = res.result.album.split(',');
          }

        }
      });
      return;
    },
    showViewer (photo) {
      let imgs = [];
      imgs.push(photo);
      this.viewerImages = imgs;
      this.$viewer.show();
    },
    // 筛选
    renderTable: function (name) {
      let params = {
        page: this.pages.current,
        size: this.pages.size,
        key: this.formItem.key,
      };
      this.$api.mangheshopgoodreturnorder.list(params).then(res => {
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
    }
  }
};
</script>
